export { default as CatSvg } from './CatSvg';
export { default as WolfSvg } from './WolfSvg';
export { default as FoxSvg } from './FoxSvg';
export { default as RabbitSvg } from './RabbitSvg';
export { default as ParrotSvg } from './ParrotSvg';
export { default as AxolotlSvg } from './AxolotlSvg';
export { default as PandaSvg } from './PandaSvg';
export { default as DragonSvg } from './DragonSvg';
export { default as SlimeSvg } from './SlimeSvg';
export { default as GenericPetSvg } from './GenericPetSvg';
export { default as OcelotSvg } from './OcelotSvg';
export { default as ChickenSvg } from './ChickenSvg';
export { default as PigSvg } from './PigSvg';
export { default as BeeSvg } from './BeeSvg';
export { default as FrogSvg } from './FrogSvg';
export { default as AllaySvg } from './AllaySvg';
export { default as ArmadilloSvg } from './ArmadilloSvg';
export { default as SnifferSvg } from './SnifferSvg';
export { default as TurtleSvg } from './TurtleSvg';
export { default as CowSvg } from './CowSvg';
export { default as SheepSvg } from './SheepSvg';
export { default as GoatSvg } from './GoatSvg';
export { default as CamelSvg } from './CamelSvg';
export { default as DolphinSvg } from './DolphinSvg';
export { default as StriderSvg } from './StriderSvg';
export { default as PolarBearSvg } from './PolarBearSvg';
export { default as IronGolemSvg } from './IronGolemSvg';
export { default as SnowGolemSvg } from './SnowGolemSvg';
export { default as HorseSvg } from './HorseSvg';
export { default as LlamaSvg } from './LlamaSvg';
export { default as WispSvg } from './WispSvg';
export { default as HermitCrabSvg } from './HermitCrabSvg';
export { default as NimbusPupSvg } from './NimbusPupSvg';
export { default as ShadowlingSvg } from './ShadowlingSvg';
export { default as PocketPhoenixSvg } from './PocketPhoenixSvg';
export { default as ClockworkSentinelSvg } from './ClockworkSentinelSvg';
export { default as StarSpriteSvg } from './StarSpriteSvg';
export { default as LanternImpSvg } from './LanternImpSvg';
export { default as DuckParadeSvg } from './DuckParadeSvg';
export { default as MocchiRabbitSvg } from './MocchiRabbitSvg';
export { default as MiniGryphonSvg } from './MiniGryphonSvg';
export { default as PigmyKrakenSvg } from './PigmyKrakenSvg';
export { default as JellyfishBloomSvg } from './JellyfishBloomSvg';

export const PET_COMPONENTS = {
  cat: require('./CatSvg').default,
  wolf: require('./WolfSvg').default,
  fox: require('./FoxSvg').default,
  rabbit: require('./RabbitSvg').default,
  parrot: require('./ParrotSvg').default,
  axolotl: require('./AxolotlSvg').default,
  panda: require('./PandaSvg').default,
  baby_dragon: require('./DragonSvg').default,
  slime: require('./SlimeSvg').default,
  ocelot: require('./OcelotSvg').default,
  chicken: require('./ChickenSvg').default,
  pig: require('./PigSvg').default,
  bee: require('./BeeSvg').default,
  frog: require('./FrogSvg').default,
  allay: require('./AllaySvg').default,
  armadillo: require('./ArmadilloSvg').default,
  sniffer: require('./SnifferSvg').default,
  turtle: require('./TurtleSvg').default,
  cow: require('./CowSvg').default,
  sheep: require('./SheepSvg').default,
  goat: require('./GoatSvg').default,
  camel: require('./CamelSvg').default,
  dolphin: require('./DolphinSvg').default,
  strider: require('./StriderSvg').default,
  polar_bear: require('./PolarBearSvg').default,
  iron_golem: require('./IronGolemSvg').default,
  snow_golem: require('./SnowGolemSvg').default,
  horse: require('./HorseSvg').default,
  llama: require('./LlamaSvg').default,
  wisp: require('./WispSvg').default,
  hermit_crab: require('./HermitCrabSvg').default,
  nimbus_pup: require('./NimbusPupSvg').default,
  shadowling: require('./ShadowlingSvg').default,
  pocket_phoenix: require('./PocketPhoenixSvg').default,
  clockwork_sentinel: require('./ClockworkSentinelSvg').default,
  star_sprite: require('./StarSpriteSvg').default,
  lantern_imp: require('./LanternImpSvg').default,
  duck_parade: require('./DuckParadeSvg').default,
  mocchi_rabbit: require('./MocchiRabbitSvg').default,
  mini_gryphon: require('./MiniGryphonSvg').default,
  pigmy_kraken: require('./PigmyKrakenSvg').default,
  jellyfish_bloom: require('./JellyfishBloomSvg').default,
};

const artComponents = {};

/**
 * The generated voxel-chibi art when a species has it, which is all of them,
 * and the hand-built SVG otherwise. Components are made once per species so
 * React keeps them stable between renders.
 */
export function getPetComponent(petTypeId) {
  const { artIdFor, makeArtPet } = require('./ArtPet');
  if (artIdFor(petTypeId)) {
    artComponents[petTypeId] = artComponents[petTypeId] || makeArtPet(petTypeId);
    return artComponents[petTypeId];
  }
  return PET_COMPONENTS[petTypeId] || require('./GenericPetSvg').default;
}
